module.exports = __webpack_public_path__ + "img/icon.e73a253c.png";